const $ = require('jquery');
'use strict';
///*------------------------------------------
///* всплывающая форма при заказе консультации   
///*------------------------------------------
const formPopupHandler = (() => { 
	$(document).on('change', '#formService input[name="valTrFal"]', function() {
	if($(this).val()==="valTrFal_true") {	 
	  $(".fofm button[type=submit]").removeAttr('disabled');
	  $('.fofm input[type=hidden].valTrFal').val('valTrFal_true');
	}
	else {
		$(".fofm button[type=submit]").attr('disabled','disabled');
		$('.fofm input[type=hidden].valTrFal').val('valTrFal_disabled');
	}
});
 
$("#formService").submit(function() {
	 if($('#formService input[name="valTrFal"]').val()!=="valTrFal_true") {
	 	$(".fofm button[type=submit]").attr('disabled','disabled');
		$('.fofm input[type=hidden].valTrFal').val('valTrFal_disabled');
	 }
 const data = $(this).serialize();
	$.ajax({
	type: "POST",
	url: "php/contact.php",
	data: data,
	success: function(msg) {
		if(msg == 'ok') {
			$('.popup2, .overlay-f').css('opacity','1');
			$('.popup2, .overlay-f').css('visibility','visible');
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#order-calculation textarea').val('');
			$(':input','#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		}
		else {
			$('.popup2 .window').html(
			'<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>'); 
			$('.popup2, .overlay-f').css('opacity','1'); 
			$('.popup2, .overlay-f').css('visibility','visible'); 
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#order-calculation textarea').val('');
			$(':input','#formService').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		} 
	} 
	}); 
	return false; 
	}); 
});
export default formPopupHandler;


// WEBPACK FOOTER //
// ./app/components/modalform.js